module.exports = {"proxy_url":"https://proxy.benjandsara.com/","image_sizes":[200,400,640,750,828,1136,1334,1472,1536,2048]}


//////////////////
// WEBPACK FOOTER
// ./src/config/smugmug.yaml
// module id = 178
// module chunks = 1474